import { List, ListItem, ListItemText } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import Popover from '@material-ui/core/Popover';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import DropdownIcon from '@material-ui/icons/ArrowDropDown';
import { observer } from 'mobx-react-lite';
import React, { useContext, useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import MobxContext from '../mobx/MobxContext';
import NoResultsText from '../common/NoResultsText';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    navButton: {
      textTransform: 'none',
      fontWeight: 'bold'
    },
    textFieldInput: {
      paddingTop: 12,
      paddingBottom: 12
    },
    content: {
      padding: 16,
      width: 350,
      minHeight: 300
    },
    footer: {
      borderTop: `1px solid ${theme.palette.divider}`,
      padding: '8px 16px',
      display: 'flex',
      justifyContent: 'center'
    },
    searchField: {
      marginBottom: 16
    },
    list: {
      margin: '0 -16px'
    }
  })
);

function FamilyMenuButton(props: RouteComponentProps) {
  const classes = useStyles({});
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const [search, setSearch] = useState('');
  const { familyStore, preferenceStore } = useContext(MobxContext);

  const onViewFamily = (id: string) => () => {
    setSearch('');
    onMenuClose();
    props.history.push(`/families/${id}`);
  }

  function onMenuOpen(event: React.MouseEvent<HTMLButtonElement>) {
    setMenuAnchorEl(event.currentTarget);
  }

  function onMenuClose() {
    setMenuAnchorEl(null);
  }

  function onViewFamilies() {
    setSearch('');
    onMenuClose();
    props.history.push('/families');
  }

  function onSearchChange(event: React.ChangeEvent<HTMLInputElement>) {
    setSearch(event.target.value);
  }

  const normalizedSearch = search.toLowerCase();

  const families = normalizedSearch && familyStore.families ?
    familyStore.families.filter(family => family.name.toLowerCase().includes(normalizedSearch)).slice(0, 5) : preferenceStore.recentlyViewedFamilies;

  return (
    <div>
      <Button onClick={onMenuOpen} color="inherit" className={classes.navButton}>Families <DropdownIcon /></Button>
      <Popover
        id="account-menu"
        open={Boolean(menuAnchorEl)}
        anchorEl={menuAnchorEl}
        onClose={onMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <div className={classes.content}>
          <TextField
            id="search"
            value={search}
            className={classes.searchField}
            fullWidth
            margin="none"
            variant="outlined"
            placeholder="Search by family name"
            autoComplete="off"
            inputProps={{ 'aria-label': 'bare', className: classes.textFieldInput }}
            onChange={onSearchChange}
          />
          {!search && families && families.length > 0 && <Typography color="textSecondary">Recently Viewed</Typography>}
          <List dense disablePadding className={classes.list}>
            {families.map(family => <ListItem key={family.id} button onClick={onViewFamily(family.id)}>
              <ListItemText primary={family.name} />
            </ListItem>)}
          </List>
          {!search && families && families.length === 0 && <NoResultsText>No recently viewed families</NoResultsText>}
          {search && families && families.length === 0 && <NoResultsText>No families matching search</NoResultsText>}
        </div>
        <div className={classes.footer}>
          <Link variant="subtitle1" color="primary" component="button" onClick={onViewFamilies}>View All Families</Link>
        </div>
      </Popover>
    </div>
  );
};

export default withRouter(observer(FamilyMenuButton));
